import React from 'react';
import Sidebar from '../components/Sidebar';
import { Box, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #01183b 0%, #2c3e55 100%)'
            }}
        >
            <CssBaseline />

            {/* Main content area with Sidebar */}
            <Box sx={{ display: 'flex', flex: 1 }}>
                <Sidebar />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 1,
                        m: 1,
                        bgcolor: '#E0E0E0',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: 'calc(100vh - 1rem)', // Adjust for padding/margins
                    }}
                >
                    {/* Scrollable Outlet Area */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            pr: 1,
                            // Hide scrollbar (Chrome/Safari)
                            '&::-webkit-scrollbar': {
                                width: 0,
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: 'transparent',
                            },
                            // Hide scrollbar (Firefox/IE)
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                        }}
                    >
                        <Outlet />
                    </Box>

                    {/* Footer */}
                    <Box
                        component="footer"
                        sx={{
                            textAlign: 'center',
                            color: '#333',
                            fontSize: '12px',
                            mt: 1,
                        }}
                    >
                        © {new Date().getFullYear()}, Sr4Dx Pvt Ltd. All rights reserved.
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MainLayout;
